import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    updateChannel = new Subject();
    detailChannel = new Subject();
    repository = new UpdateRepository()
    signatoryChannel = new Subject();
    parentChannel = new Subject();
    typeChannel = new Subject();
   
   
    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchUpdate = async (query) => {
        this.updateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchUpdate(query).then((result) => {
            this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.updateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    
    fetchSignatory = async (query) => {
        this.signatoryChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSignatoryOfficial(query).then((result) => {
            this.signatoryChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.signatoryChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchType = async (query) => {
        this.typeChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchType(query).then((result) => {
            this.typeChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.typeChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchParent = async (query) => {
        this.parentChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchParent(query).then((result) => {
            this.parentChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.parentChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default UpdateBloc